<script>
  export let id;

  export let numberOfItems;

  export let controlsBackground = 'var(--black)';
</script>

<div id="carousel{id}" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <slot></slot>
  </div>

  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#carousel{id}"
    data-bs-slide="prev"
    style="background-color: {controlsBackground};"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>

  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#carousel{id}"
    data-bs-slide="next"
    style="background-color: {controlsBackground};"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>

  <div class="carousel-indicators mt-3 mb-0">
    {#each { length: numberOfItems } as _, index}
      <button
        type="button"
        data-bs-target="#carousel{id}"
        data-bs-slide-to={index}
        class:active={index === 0}
        aria-current={index === 0 ? 'true' : 'false'}
        aria-label="Slide {index + 1}"
      ></button>
    {/each}
  </div>
</div>

<style>
  .carousel-indicators {
    position: relative;
  }

  @media (min-width: 1000px) {
    .carousel-control-prev,
    .carousel-control-next {
      opacity: 0.7;
    }

    .carousel-control-prev:hover,
    .carousel-control-next:hover {
      opacity: 1;
    }
  }

  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='f8f8f8'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  }

  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='f8f8f8'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
  }

  .carousel .carousel-indicators [data-bs-target] {
    background-color: #f8f8f8;
  }
</style>
